export const HIDE_REFUND_INFO_KEY = 'hide-how-refund-works-dialog';
